(() => {
  "use strict";

  const SUPPLY_MAP = ["30 Day Supply", "90 Day Supply", "150 Day Supply"];
  const DELIVERY_MAP = [
    "Delivery every month",
    "Delivery every 3 months",
    "Delivery every 5 months",
  ];

  function pickBundleBlock() {
    const wrapper = document.querySelector(
      ".kaching-style--v3-orange-black-single"
    );
    if (!wrapper) return null;
    return wrapper.querySelector("kaching-bundles-block") || wrapper;
  }

  function isSubscriptionSelected(bundleBlock) {
    const subsRoot = bundleBlock.querySelector(
      ".kaching-bundles__subscriptions"
    );
    if (!subsRoot) return false;

    const selected =
      subsRoot.querySelector(
        ".kaching-bundles__subscriptions__card.kaching-bundles__bar-container--selected"
      ) ||
      subsRoot.querySelector('[aria-checked="true"]');

    const form =
      bundleBlock.closest("form.kaching-bundle-form") ||
      document.querySelector("form.kaching-bundle-form");

    const sellingPlanInput = form?.querySelector(
      'input[name="selling_plan"][value]:not([value=""])'
    );

    return Boolean(selected || sellingPlanInput);
  }

  function initV3OrangeBlackSingle() {
    const bundleBlock = pickBundleBlock();
    if (!bundleBlock) return;

    function apply() {
      const isSub = isSubscriptionSelected(bundleBlock);

      const barsWrapper = bundleBlock.querySelector(
        ".kaching-bundles__bars"
      );
      if (!barsWrapper) return;

      const bars = barsWrapper.querySelectorAll(".kaching-bundles__bar");

      bars.forEach((bar, index) => {
        const contentLeft =
          bar.querySelector(".kaching-bundles__bar-content-left") ||
          bar.querySelector(".kaching-bundles__bar-content") ||
          bar;

        /* ---------- SUPPLY ---------- */
        const title =
          bar.querySelector(".kaching-bundles__bar-title") ||
          bar.querySelector(".kaching-bundles__block-title");

        if (title) {
          let supply = title.querySelector(".md-supply");
          if (!supply) {
            supply = document.createElement("span");
            supply.className = "md-supply";
            supply.style.fontWeight = "400";
            title.appendChild(supply);
          }
          supply.textContent = ` (${SUPPLY_MAP[index]})`;
        }

        /* ---------- SAVINGS + FREE SHIPPING ---------- */
        const secondLine =
          bar.querySelector(".kaching-bundles__bar-second-line") ||
          bar.querySelector(".kaching-bundles__bar-subtitle");

        if (secondLine) {
          let ship = secondLine.querySelector(".md-inline-shipping");

          // 🔥 HARD RULE:
          // One-time + first bar → REMOVE node entirely
          if (!isSub && index === 0) {
            if (ship) ship.remove();
          } else {
            if (!ship) {
              ship = document.createElement("span");
              ship.className = "md-inline-shipping";
              secondLine.appendChild(ship);
            }
            ship.textContent = "+ FREE Shipping";
          }
        }

        /* ---------- 🎁 FREE GIFT (SUBSCRIPTION ONLY) ---------- */
        let third = contentLeft.querySelector(
          ".kaching-bundles__bar-third-line"
        );

        if (isSub) {
          if (!third) {
            third = document.createElement("div");
            third.className = "kaching-bundles__bar-third-line visible";
            secondLine.after(third);
          }
          third.innerHTML = `<span class="md-inline-gift">🎁 1 FREE Gift</span>`;
        } else if (third) {
          third.remove();
        }

        /* ---------- 🚚 DELIVERY (SUBSCRIPTION ONLY) ---------- */
        let fourth = contentLeft.querySelector(
          ".kaching-bundles__bar-fourth-line"
        );

        if (isSub) {
          if (!fourth) {
            fourth = document.createElement("div");
            fourth.className = "kaching-bundles__bar-fourth-line visible";
            (third || secondLine).after(fourth);
          }
          fourth.textContent = DELIVERY_MAP[index];
        } else if (fourth) {
          fourth.remove();
        }
      });
    }

    let t;
    function scheduleUpdate(delay = 80) {
      clearTimeout(t);
      t = setTimeout(apply, delay);
    }

    scheduleUpdate(120);

    bundleBlock.addEventListener("click", () => scheduleUpdate(60));
    bundleBlock.addEventListener("change", () => scheduleUpdate(60));

    if (!bundleBlock.__obs) {
      const obs = new MutationObserver(() => scheduleUpdate(100));
      obs.observe(bundleBlock, { childList: true, subtree: true });
      bundleBlock.__obs = obs;
    }
  }

  function initAll() {
    initV3OrangeBlackSingle();
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll);

  if (window.customElements?.whenDefined) {
    customElements
      .whenDefined("kaching-bundles-block")
      .then(() => setTimeout(initAll, 120))
      .catch(() => {});
  }
})();
